const MUTATION_KEY = "mutate";

const BASE_QUERY_KEY = "advanced-search-filtering";

const FILTERS_SELECTION_QUERY_KEY = "filters-selection";

export const advancedSearchFilteringQueryKeys = {
    filtersSelection: () => [BASE_QUERY_KEY, FILTERS_SELECTION_QUERY_KEY] as const,

    filtersSelectionMutation: () => [BASE_QUERY_KEY, MUTATION_KEY, FILTERS_SELECTION_QUERY_KEY] as const,
} as const;
